<div
  id="input-email"
  [formGroup]="formGroup"
  #inputEmail
>
  <tui-input
    [formControlName]="formControlName"
    [nativeId]="id"
    [pseudoFocus]="focus ?? null"
    [pseudoInvalid]="invalid === undefined ? null : invalid"
    [readOnly]="properties?.readOnly ?? false"
    [tuiHintContent]="hintContent"
    [tuiTextfieldCleaner]="true"
    [tuiTextfieldIconLeft]="icon"
    [tuiTextfieldPostfix]="postfix"
    [tuiTextfieldPrefix]="prefix"
    [tuiTextfieldSize]="size"
    (focusedChange)="handleFocusedChange($event)"
  >
    {{ label }}
    <span
      class="tui-required"
      *ngIf="validators.required"
    ></span>
    <input
      tuiTextfield
      [attr.type]="'email'"
      [attr.placeholder]="placeholder ?? ''"
      [attr.required]="validators.required"
    />
  </tui-input>
  <div
    #dropdown
    [class.input-email-s]="size === 's'"
    [class.input-email-m]="size === 'm'"
    [class.input-email-l]="size === 'l'"
    [style.top]="dropdownPosition"
    id="suggestions"
    *ngIf="suggestions && suggestions.length > 0"
  >
    <div id="suggestions-container"
      ><div
        class="suggestion"
        *ngFor="let domain of suggestions"
        (click)="selectDomain(domain)"
        >{{ domain }}</div
      ></div
    >
  </div>
</div>
